import RenderMessage from '../garvan-react/Components/ModalFeedback/RenderMessage'

export const page_not_found = 'Sorry, this page cannot be found!'
function NotFound() {
  return (
    <RenderMessage
      message={{
        message: '',
        subject: page_not_found,
        severity: 'warning',
        loading: false,
      }}
    />
  )
}

export default NotFound
